<div class="flex align-items-center flex-wrap gap-2 m-2">
  @if(attachments) { @for(attachment of attachments; track $index) {
  @if(showAllAttachments || $index < 4) {
  <div
    (click)="attachmentOption.toggle($event)"
    [pTooltip]="attachmentDetails"
    tooltipPosition="bottom"
    tooltipStyleClass="w-auto max-w-full"
    autoHide="false"
    class="cursor-pointer border-1 border-round py-2 px-3 surface-border font-normal w-11rem flex gap-2 align-items-center"
  >
    <img
      [style]="'width: 1.3rem'"
      class="-ml-2"
      [src]="
        getFile(
          attachment.filename
            ? attachment.filename.split('.').pop()?.toLocaleLowerCase() || ''
            : attachment.name.split('.').pop() || ''
        )
      "
    />
    <div
      class="flex flex-column w-9 justify-content-between attachment_container"
    >
      <p
        class="m-0 p-0 text-xs overflow-hidden white-space-nowrap text-overflow-ellipsis"
      >
        <b>{{ attachment.filename || attachment.name }}</b>
      </p>
      <p
        class="m-0 p-0 text-xs text-color-secondary overflow-hidden white-space-nowrap text-overflow-ellipsis"
      >
        MD5: {{ attachment.MD5 }}
      </p>
    </div>
    <p-button [text]="true" styleClass="surface-card text-color-secondary p-0">
      <i class="pi pi-chevron-down text-xs"></i>
    </p-button>
    <p-menu
      #attachmentOption
      [popup]="true"
      [model]="attachmentOptions"
      styleClass="overflow-y-scroll text-xs md:w-11rem sm:w-7rem"
      appendTo="body"
    >
      <ng-template pTemplate="item" let-item>
        <div
          (click)="item.func(attachment, $event)"
          pRipple
          class="flex align-items-center p-2 gap-2 text-color-secondary"
        >
          <svg-icon color="#424242" [key]="item.icon"></svg-icon>
          <span>{{ item.title }}</span>
        </div>
      </ng-template>
    </p-menu>
    <ng-template #attachmentDetails>
      <div>
        <p class="m-0 p-0 white-space-nowrap">
          <b>Name: </b>{{ attachment.filename || attachment.name }}
        </p>
        <p class="m-0 p-0 white-space-nowrap">
          <b>MD5: </b>{{ attachment.MD5 }}
        </p>
      </div>
    </ng-template>
  </div>
  } } @if(attachments.length > 4) {
  <div class="w-full mt-1" (mouseenter)="isHovered = true"
  (mouseleave)="isHovered = false">
    <p
      class="flex align-items-center gap-2 text-xs text-primary-700 cursor-pointer hover:text-primary m-0 p-0"
      (click)="showAllAttachments = !showAllAttachments"
    >
      <svg-icon
        [key]="showAllAttachments ? 'keyboard-double-arrow-up' : 'keyboard-double-arrow-down'"
        [color]="isHovered ? '--primary-color' : '--primary-700'"
        size="sm"

      ></svg-icon>
      {{
        showAllAttachments
          ? "Show less"
          : "Show all attachments (" + (attachments.length - 4) + " more)"
      }}
    </p>
  </div>
  } }
</div>
